import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import formatMoney from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'

export const Credited = ({ transfer = null }) => {
  if (!transfer) {
    return null
  }
  const { account } = transfer
  const { t } = useTranslation(['billing'])
  const { value = null, currency } = account

  if (value === null) {
    return null
  }

  return (
    <div className={styles['billing__will-be-credited']}>
      {t('will_be_credited')}{' '}
      <span
        className={styles['billing__will-be-credited-money']}
        dangerouslySetInnerHTML={{
          __html: formatMoney(value, currency),
        }}
      ></span>
    </div>
  )
}

Credited.propTypes = {
  transfer: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.oneOf(CURRENCIES),
  }),
}
